module.exports = __webpack_public_path__ + "static/12-cabd955952f0f5bdc252288d1ac8a8d2.jpg";